// © Microsoft Corporation. All rights reserved.

import { Comment } from "./Comments";
import { TopCommentLocalizedStrings } from "./TopCommentData";

export interface SocialBarData {
    totalCommentsCount?: number;
    reactionCounts?: ReactionCounts,
    id: string;
    myReaction?: string;
    topComments?: Array<Comment>; // id list
    reactionsOptedOut?: boolean;
    commentsOptedOut?: boolean;
}

export interface SocialBarLocalizedStrings extends TopCommentLocalizedStrings {
    ariaLabelsOpenReplies?: string;
    emojiLabellike?: string;
    emojiLabellove?: string;
    emojiLabelsurprised?: string;
    emojiLabelthinking?: string;
    emojiLabelsad?: string;
    emojiLabelangry?: string;
    emojiLabelreact?: string;
    thousandsShort?: string;
    reactionMenuAriaLabel?: string;
    ariaLabelShowReactions?: string;
    ariaLabelReactions?: string;
    ariaLabelCommentsCount?: string;
    ariaLabelReactionsCount?: string;
    ariaLabelReactionButtonSingular?: string;
    ariaLabelReactionButtonPlural?: string;
}

export enum SocialReactions {
    like = "like",
    love = "love",
    surprised = "surprised",
    thinking = "thinking",
    sad = "sad",
    angry = "angry"
}

export interface ReactionCounts {
    sad?: number;
    like?: number;
    surprised?: number;
    angry?: number;
    love?: number
    thinking?: number;
}